export default __webpack_public_path__ + "static/media/goldleaf.d346f79b.png";